if (!customElements.get('finish-3d-reminder')) {
  customElements.define('finish-3d-reminder', class extends HTMLElement {
    connectedCallback() {
      this.gallery = this.closest('media-gallery');
      this.viewer = this.gallery?.querySelector('pent-3d-viewer');
      if (!this.viewer) return;
      this.refreshSoon = () => {
        cancelAnimationFrame(this.refreshFrame);
        this.refreshFrame = requestAnimationFrame(() => this.refresh());
      };
      this.launch = event => {
        event.preventDefault();
        event.stopPropagation();
        // Reuse the native launch path, including selection and lazy loading.
        this.gallery.querySelector('.pent-3d-thumbnail')?.click();
        this.refreshSoon();
      };
      this.addEventListener('click', this.launch);
      document.addEventListener('change', this.refreshSoon);
      document.addEventListener('sportova:swatches-changed', this.refreshSoon);
      this.gallery.addEventListener('load', this.refreshSoon, true);
      this.observer = new MutationObserver(this.refreshSoon);
      this.observer.observe(this.gallery, { subtree: true, attributes: true, attributeFilter: ['class'] });
      this.resizeObserver = new ResizeObserver(this.refreshSoon);
      this.resizeObserver.observe(this.gallery);
      this.refreshSoon();
    }
    refresh() {
      const section = CSS.escape(this.viewer.dataset.section);
      const picker = document.querySelector(`variant-radios[data-section="${section}"],variant-selects[data-section="${section}"]`);
      const extra = document.querySelector(`[data-extra-finish-options][data-section="${section}"]`);
      const groups = [picker, extra].filter(Boolean).flatMap(root => [...root.querySelectorAll('.product-form__input')].filter(g => g.querySelector('.sportova-swatch')));
      const complete = groups.length > 0 && groups.every(group => group.dataset.sportovaSwatchTouched === 'true' && group.querySelector('input:checked,select'));
      const in3d = Boolean(this.gallery.querySelector('.product__media-item.is-active pent-3d-viewer'));
      const image = this.gallery.querySelector('.product__media-item.is-active .product__media img');
      this.hidden = !complete || in3d || !image;
      if (!this.hidden) {
        const slider = this.closest('[id^="GalleryViewer"]');
        if (!image || !slider || !image.naturalWidth) return;
        const bounds = image.getBoundingClientRect(), parent = slider.getBoundingClientRect();
        const frame = image.closest('.product__media').getBoundingClientRect();
        const style = getComputedStyle(image);
        let bottom = Math.min(bounds.bottom, frame.bottom), right = Math.min(bounds.right, frame.right);
        if (style.objectFit === 'contain') {
          const pw = parseFloat(style.paddingLeft) + parseFloat(style.paddingRight);
          const ph = parseFloat(style.paddingTop) + parseFloat(style.paddingBottom);
          const width = bounds.width - pw, height = bounds.height - ph;
          const scale = Math.min(width / image.naturalWidth, height / image.naturalHeight);
          const paintedHeight = scale * image.naturalHeight, paintedWidth = scale * image.naturalWidth;
          bottom = Math.min(frame.bottom, bounds.top + ph / 2 + (height + paintedHeight) / 2);
          right = Math.min(frame.right, bounds.left + pw / 2 + (width + paintedWidth) / 2);
        }
        this.style.bottom = `${Math.max(12, parent.bottom - bottom + 12)}px`;
        this.style.right = `${Math.max(12, parent.right - right + 12)}px`;
      }
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.refreshFrame);
      this.observer?.disconnect();
      this.resizeObserver?.disconnect();
      this.gallery?.removeEventListener('load', this.refreshSoon, true);
      this.removeEventListener('click', this.launch);
      document.removeEventListener('change', this.refreshSoon);
      document.removeEventListener('sportova:swatches-changed', this.refreshSoon);
    }
  });
}
